import { render, staticRenderFns } from "./indicacao-detail.vue?vue&type=template&id=47a5872c&"
import script from "./indicacao-detail.vue?vue&type=script&lang=js&"
export * from "./indicacao-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports